import { AfterViewInit, ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';

import { Store } from '@ngrx/store';
import { BehaviorSubject, Subject } from 'rxjs';
import { filter, take, takeUntil } from 'rxjs/operators';

import { TranslocoService } from '@ngneat/transloco';

import { MenuItem } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { AuthService } from '@auth/services';
import { OrderService } from '@order/services';
import { OrderActions } from '@order/state';

@Component({
  selector: 'z-add-item-dialog',
  templateUrl: './add-item-dialog.component.html',
  styleUrls: ['./add-item-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailAddItemDialogComponent implements OnInit, OnDestroy, AfterViewInit {
  destroy$ = new Subject<void>();

  steps$ = new BehaviorSubject<MenuItem[]>([]);

  translate = (key: string | string[], params?: Record<string, string>, lang?: string) =>
    this.translocoService.translate(key, params, lang);

  constructor(
    private store: Store,
    private ref: DynamicDialogRef,
    private translocoService: TranslocoService,
    public orderService: OrderService,
    private config: DynamicDialogConfig,
    public authService: AuthService
  ) {}

  ngOnInit() {
    this.authService.hasPassThru$.pipe(take(1)).subscribe((hasPassThru) => {
      const steps = [];

      steps.push({
        label: this.translate('order.add_item_dialog.steps.step_0'),
        command: () => {
          this.store.dispatch(OrderActions.AddItemDialogSetStep({ step: 0 }));
        },
      });

      steps.push({
        label: this.translate('order.add_item_dialog.steps.step_1'),
        command: () => {
          this.store.dispatch(OrderActions.AddItemDialogSetStep({ step: 1 }));
        },
      });

      if (hasPassThru === 'Y') {
        steps.push({
          label: this.translate('order.add_item_dialog.steps.step_2'),
          command: () => {
            this.store.dispatch(OrderActions.AddItemDialogSetStep({ step: 2 }));
          },
        });
      }

      this.steps$.next(steps);
    });

    this.orderService.addItemDisplay$
      .pipe(
        filter((x) => !x),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        this.ref.close(undefined);
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();

    this.store.dispatch(OrderActions.AddItemDialogClearItem());
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.orderService.addItemStep$.pipe(takeUntil(this.destroy$)).subscribe((step) => {
        if (step === 0) {
          this.config.header = this.translate('order.add_item_dialog.step_0.dialog.title');
          this.config.styleClass = this.config.styleClass.replace(/step-\d/gi, 'step-0');
        } else if (step === 1) {
          this.config.header = this.translate('order.add_item_dialog.step_1.dialog.title');
          this.config.styleClass = this.config.styleClass.replace(/step-\d/gi, 'step-1');
        } else {
          this.config.header = this.translate('order.add_item_dialog.step_2.dialog.title');
          this.config.styleClass = this.config.styleClass.replace(/step-\d/gi, 'step-2');
        }
      });
    }, 0);
  }
}
